module.exports = __webpack_public_path__ + "img/aai.acff528b.png";